import React from 'react';
import { Pagination, Button, Modal, PageHeader, Input, Spin } from 'antd';
import { DeleteFilled, PlusOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import CustomModal from '../../../components/common/CustomModal';
import * as constant from '../../../actions/constant';
import { getTopic, removeTopic, addTopic } from '../../admin/actions/adminActions';
import { connect } from 'react-redux';

const { confirm } = Modal;

interface TopicItem {
  _id: string;
  topicname: string;
}

interface TopicListProps {
  form: any; // Ant Design v3 form instance
  getTopic: (payload: any) => void;
  removeTopic: (payload: any) => void;
  addTopic: (payload: any) => void;
  topicData: TopicItem[];
  totalCount: number;
}

interface TopicListState {
  currentPage: number;
  totalRecord: number;
  visible: boolean;
  topicData: TopicItem[];
  topicId: string;
  sortValue: string;
  sortOrder: number | '';
  loading: boolean;
  search_string?: string;
}

class TopicList extends React.Component<TopicListProps, TopicListState> {
  constructor(props: TopicListProps) {
    super(props);
    this.state = {
      currentPage: 0,
      totalRecord: 0,
      visible: false,
      topicData: [],
      topicId: '',
      sortValue: '',
      sortOrder: '',
      loading: true,
    };
  }

  componentDidMount() {
    const obj = {
      page: this.state.currentPage,
      sortValue: this.state.sortValue,
      sortOrder: this.state.sortOrder,
    };
    this.props.getTopic(obj);
  }

  showModal = (id: string, name: string) => {
    this.setState({
      visible: true,
      topicId: id,
    });
    if (id !== '') {
      this.props.form.setFieldsValue({ topicname: name });
    }
  };

  handleOk = () => {
    this.props.form.validateFields((err: any, values: { topicname: string }) => {
      const obj = {
        topicname: values.topicname,
        topicId: this.state.topicId,
      };
      if (!err) {
        this.setState({ visible: false });
        this.props.addTopic(obj);
      } else {
        // keep modal open on validation error
      }
    });
  };

  handleCancel = () => {
    this.setState({ visible: false });
  };

  searchString(e: React.ChangeEvent<HTMLInputElement>) {
    this.setState({
      search_string: e.target.value,
    });
    const obj = {
      search_string: e.target.value,
      page: this.state.currentPage,
      sortValue: this.state.sortValue,
      sortOrder: this.state.sortOrder,
    };
    this.props.getTopic(obj);
  }

  showConfirm(sportId: string) {
    const self = this;
    const obj = {
      topicId: sportId,
    };
    confirm({
      title: constant.DELETE_RECORD,
      content: '',
      onOk() {
        self.props.removeTopic(obj);
      },
      onCancel() {},
    });
  }

  changePage(page: number, pageSize?: number) {
    this.setState({
      currentPage: page - 1,
    });
    const obj = {
      page: page - 1,
      sortValue: this.state.sortValue,
      sortOrder: this.state.sortOrder,
    };
    this.props.getTopic(obj);
  }

  sortData(sortVal: string) {
    const nextOrder = this.state.sortOrder === -1 ? 1 : -1;
    this.setState({
      sortOrder: nextOrder,
    });
    const obj = {
      page: this.state.currentPage,
      sortValue: sortVal,
      sortOrder: nextOrder,
    };
    this.props.getTopic(obj);
  }

  // Using UNSAFE_ prefix because this is legacy lifecycle; behavior preserved
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps: TopicListProps) {
    const data = nextProps.topicData;
    this.setState({ topicData: data, totalRecord: nextProps.totalCount, loading: false });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const state = this.state;

    const topic = state.topicData.map((x) => (
      <tr key={x._id}>
        <td>{x.topicname}</td>
        <td className="action-icons">
          <Button
            type="link"
            className="btn-sm mr-2"
            onClick={this.showModal.bind(this, x._id, x.topicname)}
          >
            <i className="fa fa-pencil" style={{ color: '#666' }} />
          </Button>
          <Button
            type="link"
            className="btn-sm mr-2"
            onClick={this.showConfirm.bind(this, x._id)}
          >
            <DeleteFilled style={{ color: '#666' }} />
          </Button>
        </td>
      </tr>
    ));

    return (
      <>
        <div className="box box-default mb-4">
          <PageHeader
            title="FAQ"
            subTitle=""
            extra={[
              <Input
                placeholder="Search"
                onChange={this.searchString.bind(this)}
                key="search"
                className="mobile-bottom-space"
                style={{ width: 'auto' }}
              />,
              <Button
                key="1"
                type="default"
                onClick={this.showModal.bind(this, '', '')}
              >
                <PlusOutlined />
                Add FAQ
              </Button>,
            ]}
          />
          <Spin spinning={this.state.loading} delay={500}>
            <div className="box-body">
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        onClick={this.sortData.bind(this, 'topicname')}
                        className="cursor-pointer"
                      >
                        FAQ Name{' '}
                        {this.state.sortOrder === 1 ? (
                          <i className="fa fa-sort-amount-asc" aria-hidden="true" />
                        ) : (
                          <i className="fa fa-sort-amount-desc" aria-hidden="true" />
                        )}
                      </th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>{topic}</tbody>
                </table>
              </div>
              <Pagination
                style={{ textAlign: 'right' }}
                pageSize={5}
                defaultCurrent={this.state.currentPage}
                total={this.state.totalRecord ? this.state.totalRecord : 1}
                onChange={this.changePage.bind(this)}
              />
              <CustomModal
                handleCancel={this.handleCancel}
                handleOk={this.handleOk}
                visible={this.state.visible}
                title="Topic"
                backBtnText="Back"
                submitBtnText="Submit"
              >
                <Form className="sport-form l_hgt0">
                  <Form.Item label="Topic Name">
                    {getFieldDecorator('topicname', {
                      rules: [{ required: true, whitespace: true, message: 'Please enter topic' }],
                    })(<Input placeholder="Topic" />)}
                  </Form.Item>
                </Form>
              </CustomModal>
            </div>
          </Spin>
        </div>
      </>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    topicData: state.admin.topicData,
    totalCount: state.admin.topicCount,
  };
}

const Topic = Form.create({ name: 'topic' })(TopicList as any);

export default connect(mapStateToProps, { getTopic, addTopic, removeTopic })(Topic as any);












